import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-white text-gray-900 border border-gray-200 shadow-lg",
          description: "text-gray-500",
          actionButton:
            "bg-gray-900 text-white",
          cancelButton:
            "bg-gray-100 text-gray-600",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
